const data = [
  {
    Name: "Aaditya Shirke",
    Board: "Assistant",
    Position: "Assistant Secretary",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398167/IMG_20240813_232523_-_Aaditya_Shirke_do8e7v.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aaditya-shirke-b29791292/",
    GitHubProfile: "https://github.com/Aadii-01",
    InstagramProfile:
      "https://www.instagram.com/aadiii__.01/",
  },

  {
    Name: "Sai Badave ",
    Board: "Assistant",
    Position: "Assistant Secretary",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398165/IMG_20240813_222701_-_Sai_Badave_zup8f0.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/saibadave",
    GitHubProfile: "https://github.com/SaiBadave",
    InstagramProfile: "",
  },

  {
    Name: "Ragini Ambi",
    Board: "Assistant",
    Position: "Assistant Program Director",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398177/IMG_20231206_140611_-_Ragini_Ambi_nxxjhc.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/ragini-ambi-ba59a428a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/Raginiambi",
    InstagramProfile: "https://www.instagram.com/raginiambi22?igsh=enNhOHp0NWVkZXo4",
  },

  {
    Name: "Upanishad Kachroo",
    Board: "Assistant",
    Position: "Assistant Program Director",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398168/WhatsApp_Image_2024-07-28_at_00.50.39_c7c5460d_-_Upanishad_Kachroo_pdo8bg.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/upanishad-kachroo-276463286/",
    GitHubProfile: "https://github.com/Upanishadkachroo",
    InstagramProfile:
      "",
  },
  {
    Name: "Pruthviraj Desai",
    Board: "Assistant",
    Position: "Assistant Program Director",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398149/IMG_20240227_172203443_-_Desai_Pruthviraj_mc7dqv.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/desai-pruthviraj-509941287?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/PrDesai2004",
    InstagramProfile: "",
  },
  {
    Name: "Dhanraj jadhav",
    Board: "Assistant",
    Position: "Assistant Program Director",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726399478/20230627_134849_2_-_Dhanraj_jadhav_fmw2id.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/dhanraj-jadhav-473451291/",
    GitHubProfile: "https://github.com/dhanraj-12",
    InstagramProfile: "",
  },

  {
    Name: "Swanand Desai",
    Board: "Assistant",
    Position: "Assistant Club Service Director",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398192/IMG_20240811_222014477-min_1_-_Swanand_Desai_PRN_.23610068_tmzgda.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/swanand-desai-b3035828b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "",
    InstagramProfile:
      "https://www.instagram.com/swanand475",
  },

  {
    Name: "Sakshi Bhosale",
    Board: "Assistant",
    Position: "Assistant Club Service Director",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398172/IMG_20240813_223102_-_Sakshi_Bhosale_vrl8rf.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/sakshi-bhosale-93b21a323",
    GitHubProfile: "",
    InstagramProfile: "",
  },

  {
    Name: "Aryan Desai",
    Board: "Assistant",
    Position: "Assistant Club Service Director",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398161/Sharing_via_Kaagaz_Scanner_-_Aryan_Desai_eousvo.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aryan-desai-35637928b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/Aryan-Desai12",
    InstagramProfile: "https://www.instagram.com/winter_soldier0012?igsh=ZHZyNWxwN2pmMWEx",
  },

  {
    Name: "Haripriya Yele",
    Board: "Assistant",
    Position: "Assistant Club Service Director",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398151/DSC_0041_-_Haripriya_Yele_px7t9w.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/haripriya-yele-38a5a5289?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/ari2507",
    InstagramProfile: "https://www.instagram.com/its_hari073/",
  },

  {
    Name: "Spandan Meshram",
    Board: "Assistant",
    Position: "Assistant Web Developer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398163/IMG_20240813_231538_-_Spandan_Meshram_ttboja.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/spandan-meshram-46941b2a8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/Spandan-m-28",
    InstagramProfile: "https://www.instagram.com/spandan_m_28/",
  },
  {
    Name: "Tanish Bhongade",
    Board: "Assistant",
    Position: "Assistant Web Developer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398186/photo_latest_-_Tanish_Bhongade_xk0grt.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/tanishbhongade",
    GitHubProfile: "https://github.com/tanishbhongade",
    InstagramProfile: "https://www.instagram.com/tanishbhongade/",
  },
  {
    Name: "Sanvi Bongale",
    Board: "Assistant",
    Position: "Assistant Web Developer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398174/20240401_201718_-_23610028_BONGALE_SANVI_NITIN_zzhflp.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/sanvi-bongale-5988b5292",
    GitHubProfile: "https://github.com/SanviBongale28",
    InstagramProfile: "https://www.instagram.com/sanvibongale?igsh=MTdrZXNlNTBoODZtNA==",
  },
  {
    Name: "Vishwadeep Sutar",
    Board: "Assistant",
    Position: "Assistant Programming Expert",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726400837/IMG-20240814-WA0008_-_23610077_SUTAR_VISHWADEEP_VISHVANATH_1_neekwh.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vishwadeep-sutar-1b65b1322",
    GitHubProfile: "https://github.com/Vishwadeep112004",
    InstagramProfile: "https://www.instagram.com/vishwadeep435/",
  },
  {
    Name: "Pratik Magdum",
    Board: "Assistant",
    Position: "Assistant Programming Expert",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398139/Screenshot_2024-09-15-16-26-07-32_92460851df6f172a4592fca41cc2d2e6_yl0hy4.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/pratik-magdum-2628b7292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "",
    InstagramProfile: "https://www.instagram.com/pratik_magdum_o9?igsh=am9hejJxaml0YnBv",
  },
  {
    Name: "Ashutosh Shingan",
    Board: "Assistant",
    Position: "Assistant Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398180/Ashu_PHOTO_-_23610070_SHINGAN_ASHUTOSH_ANANDA_ic9yge.jpg",
    LinkedInProfile: "http://www.linkedin.com/in/ashutosh-shingan-5a78ab290",
    GitHubProfile: "https://github.com/Ashushingan",
    InstagramProfile: "",
  },
  {
    Name: "Vaishnavi Bharambe",
    Board: "Assistant",
    Position: "Assistant Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398152/photo_2_-_23610010_BHARAMBE_VAISHNAVI_KAILAS_vl3js1.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vaishnavi-bharambe-646783293/",
    GitHubProfile: "https://github.com/Vaishnavi-Bharambe",
    InstagramProfile:
      "",
  },

  {
    Name: "Animesh Gawhale",
    Board: "Assistant",
    Position: "Assistant Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398145/animesh_-_Animesh_Gawhale_mrh3sm.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/animesh-gawhale-a4491b296?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/Anime181",
    InstagramProfile:
      "https://www.instagram.com/gawhaleanimesh?igsh=MXVsM3h4Y3A4a2I5OA==",
  },

  {
    Name: "Tanmay Kamble",
    Board: "Assistant",
    Position: "Assistant Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398142/23610041_-_Tanmay_Kamble_xta684.jpg",
    LinkedInProfile:
      "",
    GitHubProfile: null,
    InstagramProfile: "",
  },
  {
    Name: "Yogesh Joshi",
    Board: "Assistant",
    Position: "Assistant Aptitude Developer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398144/IMG-20240809-WA0110_-_Yogesh_Joshi_sqb2j5.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/yogesh-joshi-7a6487292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "",
    InstagramProfile:
      "",
  },

  {
    Name: "Abhishek Bhosale",
    Board: "Assistant",
    Position: "Assistant Aptitude Developer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398143/jpeg-optimizer_Image_to_PDF_20240805_115129-1_-_23610064_BHOSALE_ABHISHEK_NILAKANTH_tnjk00.jpg",
    LinkedInProfile: "",
    GitHubProfile: "",
    InstagramProfile: "",
  },
  {
    Name: "Vishant Sutar",
    Board: "Assistant",
    Position: "Asistant Editor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398190/IMG_20230928_115113_-_Vishant_Sutar_tgsawg.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vishant-sutar",
    GitHubProfile: "https://github.com/vishantsutar26/vishantsutar26",
    InstagramProfile:
      "https://www.instagram.com/vishantsutar26",
  },
  {
    Name: "Tanvi Diwan",
    Board: "Assistant",
    Position: "Assistant Art Director",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398185/20220421_211427_-_Tanvi_Diwan_xiwekw.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/tanvi-diwan-6398b6292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/tanvidiwan05",
    InstagramProfile:
      "https://www.instagram.com/tanvi.diwan.05?igsh=aXkzYW1zamxqbms2",
  },
  {
    Name: "Dnyanda Lahamage",
    Board: "Assistant",
    Position: "Assistant Art Director",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398160/InShot_20240814_000530633_-_23610083_LAHAMAGE_DNYANDA_NILESH_avwndb.jpg",
    LinkedInProfile: "",
    GitHubProfile: "",
    InstagramProfile: "",
  },
  {
    Name: "Avinash Waykule",
    Board: "Assistant",
    Position: "Assistant Treasurer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726398188/ohoto_-_avinash_waykule_ddd2rs.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/avinash-waykule-046488292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/Ssp63",
    InstagramProfile:
      "https://www.instagram.com/avinashwaykule02/",
  },
  {
    Name: "Ankita Kamble",
    Board: "Assistant",
    Position: "Assistant Treasurer",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726402381/photo_-_Ankita_Kamble_1_vtpwym.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/ankita-kamble-5453372a0/",
    GitHubProfile: "",
    InstagramProfile:
      "",
  },
];

export default data;
